module.exports = __webpack_public_path__ + "img/2020.23bc45af.jpg";